module.exports = __webpack_public_path__ + "img/txt.a7e32eb7.png";